import mixpanel from 'mixpanel-browser';

export function home() {
  mixpanel.track('calendar:home');
}